var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _linearGradient, _linearGradient2, _clipPath8, _clipPath9, _clipPath0, _clipPath1, _clipPath10, _clipPath11, _clipPath12, _linearGradient3, _linearGradient4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonJumpConnected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 91.219831 40.061372",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient48",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,23.959999,-23.959999,0,42.108498,1.4160004)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop44",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop46",
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient66",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,23.959999,-23.959999,0,42.108498,1.4160004)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop62",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop64",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient122",
    spreadMethod: "pad",
    gradientTransform: "matrix(-6.9319987,-37.229,37.229,-6.9319987,51.076389,82.212112)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop118",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop120",
    offset: 1,
    style: {
      stopOpacity: 0.39000534,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient140",
    spreadMethod: "pad",
    gradientTransform: "matrix(-6.9319987,-37.229,37.229,-6.9319987,51.076389,82.212112)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop136",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop138",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18-8",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16-5",
    d: "M 0,66 H 85 V 0 H 0 Z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath34-1",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32-2",
    d: "M 2.44701,63.258 H 81.77 V 2.07201 H 2.44701 Z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath38-0",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36-0",
    d: "M 50.574,2.072 32.196,2.074 C 15.792,2.168 2.447,15.891 2.447,32.664 c 0,16.774 13.345,30.496 29.749,30.589 l 18.378,0.005 h 14.963 c 3.625,0 6.576,-3.014 6.576,-6.721 0.035,-3.298 0.105,-9.562 0.105,-9.754 0,-3.158 0.979,-4.505 3.279,-4.505 1.77,0 2.482,1.094 3,1.896 0.48,0.73 0.74,1.134 1.695,1.134 1.547,0 1.557,-5.079 1.568,-10.458 l 0.01,-2.284 c -0.006,-0.712 -0.006,-1.411 -0.008,-2.087 -0.014,-5.377 -0.023,-10.457 -1.57,-10.457 -0.955,0 -1.215,0.404 -1.695,1.135 -0.518,0.801 -1.23,1.895 -3,1.895 -2.301,0 -3.279,-1.348 -3.279,-4.508 0,-0.189 -0.07,-6.453 -0.105,-9.738 0,-3.717 -2.951,-6.732 -6.576,-6.732 H 50.574 Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50-0",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g60-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g58-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g56-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g54-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52-5",
    style: {
      fill: "url(#linearGradient48)",
      stroke: "none"
    },
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z"
  })))))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath92-7",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90-3",
    d: "M 2.44701,63.258 H 81.77 V 31.823 H 2.44701 Z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath108-8",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106-6",
    d: "M 2.993,63.158 H 81.771 V 31.3123 H 2.993 Z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath112-2",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path110-0",
    d: "m 53.193,36.212 c 12.109,-0.183 22.918,-2.51 28.578,-3.531 -0.004,0.456 -0.008,1.542 -0.01,2.069 -0.012,5.379 -0.021,10.457 -1.568,10.457 -0.955,0 -1.215,-0.403 -1.695,-1.134 -0.518,-0.802 -1.23,-1.896 -3,-1.896 -2.301,0 -3.279,1.348 -3.279,4.505 0,0.192 -0.07,6.456 -0.105,9.755 0,3.706 -2.951,6.721 -6.576,6.721 H 50.574 c 0,0 -18.183,-0.004 -18.378,-0.006 C 17.727,63.071 5.645,52.385 2.993,38.355 c 7.453,-14.605 35.988,-1.93 50.2,-2.143"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124-5",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g134-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g132-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g130-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g128-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path126-9",
    style: {
      fill: "url(#linearGradient122)",
      stroke: "none"
    },
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z"
  })))))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath166-3",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164-2",
    d: "M 0,66 H 85 V 0 H 0 Z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient66",
    id: "linearGradient5374",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,23.959999,-23.959999,0,42.108498,1.4160004)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient140",
    id: "linearGradient5376",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-6.9319987,-37.229,37.229,-6.9319987,51.076389,82.212112)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad"
  })), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18-83",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16-9",
    d: "M 0,66 H 76 V 0 H 0 Z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath34-5",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32-8",
    d: "M 2.472,63.506 H 73.497 V 2.341 H 2.472 Z"
  }))), _clipPath0 || (_clipPath0 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath38-6",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36-2",
    d: "m 9.727,2.341 c -3.797,0 -7.255,3.203 -7.255,6.722 0,0 0.013,5.812 0.013,9.332 0,0.184 0.004,0.342 0.008,0.485 0.973,-1.427 2.396,-2.208 4.232,-2.319 0.115,-0.008 0.227,-0.011 0.333,-0.011 1.663,0 2.601,0.82 3.419,1.658 1.7,1.739 1.713,3.976 1.778,14.709 C 12.19,43.666 12.177,45.901 10.477,47.641 9.658,48.479 8.721,49.3 7.058,49.3 6.952,49.3 6.84,49.296 6.725,49.29 4.887,49.177 3.465,48.395 2.493,46.97 c -0.005,0.162 -0.008,0.323 -0.008,0.485 0,3.521 -0.013,9.332 -0.013,9.332 0,3.516 3.458,6.719 7.255,6.719 h 47.546 c 3.623,0 6.572,-3.016 6.572,-6.719 0.032,-3.298 0.104,-9.558 0.106,-9.749 0,-3.157 0.979,-4.504 3.276,-4.504 1.769,0 2.479,1.093 3,1.893 0.476,0.732 0.737,1.135 1.692,1.135 1.545,0 1.554,-5.079 1.567,-10.454 0,-0.675 0.011,-2.283 0.011,-2.283 -0.008,-0.71 -0.011,-1.409 -0.011,-2.085 -0.016,-5.374 -0.022,-10.453 -1.567,-10.453 -0.955,0 -1.219,0.404 -1.692,1.135 -0.521,0.803 -1.231,1.895 -3,1.895 -2.299,0 -3.276,-1.348 -3.276,-4.506 -0.002,-0.188 -0.074,-6.449 -0.106,-9.734 0,-3.719 -2.949,-6.732 -6.572,-6.732 H 9.727 Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient54",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,52.356018,-52.356018,0,37.984501,2.223999)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop44-9",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop46-9",
    offset: 0.127,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop48",
    offset: 0.267,
    style: {
      stopOpacity: 0.15999084,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop50",
    offset: 0.539,
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop52",
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g60-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "url(#linearGradient54)",
      stroke: "none"
    },
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient78",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,52.356018,-52.356018,0,37.984501,2.223999)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop68",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop70",
    offset: 0.127,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop72",
    offset: 0.267,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop74",
    offset: 0.539,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop76",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  })), _clipPath1 || (_clipPath1 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath104",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "m 2.472,63.508 h 71.03 V 30.7882 H 2.472 Z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath108-4",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106-4",
    d: "m 2.492,46.97 c 0.973,1.426 2.395,2.207 4.232,2.32 0.115,0.006 0.227,0.01 0.333,0.01 1.663,0 2.601,-0.82 3.419,-1.659 1.607,-1.645 1.707,-6.122 1.768,-15.423 18.04,-4.051 26.213,1.793 45.277,1.793 11.387,0 8.021,-0.692 15.975,-1.907 0.004,0.244 0.004,0.478 0.006,0.723 0,0 -0.01,1.608 -0.01,2.283 -0.016,5.375 -0.023,10.454 -1.568,10.454 -0.955,0 -1.219,-0.402 -1.693,-1.135 -0.521,-0.8 -1.23,-1.893 -3,-1.893 -2.299,0 -3.275,1.347 -3.275,4.504 -0.002,0.191 -0.074,6.451 -0.105,9.749 0,3.703 -2.949,6.719 -6.572,6.719 H 9.727 c -3.797,0 -7.255,-3.203 -7.255,-6.719 0,0 0.013,-5.811 0.013,-9.332 -10e-4,-0.185 0.003,-0.345 0.007,-0.487"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient118",
    spreadMethod: "pad",
    gradientTransform: "matrix(-5.4759989,-24.301025,24.301025,-5.4759989,42.786262,66.061951)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop114",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop116",
    offset: 1,
    style: {
      stopOpacity: 0.17000076,
      stopColor: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask120",
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g130-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g128-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path122",
    style: {
      fill: "url(#linearGradient118)",
      stroke: "none"
    },
    d: "M -32768,32767 H 32767 V -32768 H -32768 Z"
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient136",
    spreadMethod: "pad",
    gradientTransform: "matrix(-5.4759989,-24.301025,24.301025,-5.4759989,42.786262,66.061951)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop132",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop134",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#7affff"
    }
  })), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath162",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M 2.472,63.506 H 73.497 V 9.01401 H 2.472 Z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath178",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M 0,66 H 76 V 0 H 0 Z"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient78",
    id: "linearGradient4",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,52.356018,-52.356018,0,37.984501,2.223999)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient136",
    id: "linearGradient5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.4759989,-24.301025,24.301025,-5.4759989,42.786262,66.061951)",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    spreadMethod: "pad"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-53.467815,-371.51427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5430",
    transform: "matrix(1.7399538,0,0,1.7399538,-356.48388,296.40396)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,235.44311,66.186026)",
    id: "g12-2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18-8)",
    id: "g14-4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.185,0.582)",
    id: "g20-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22-5",
    style: {
      fill: "#ffea00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -17.209,0.095 -31.21,14.487 -31.21,32.082 0,17.594 14.001,31.987 31.21,32.084 l 4.439,-0.008 h 29.256 c 4.433,0 8.039,-3.684 8.039,-8.213 0,0 0.107,-9.543 0.107,-9.749 0,-3.011 0.92,-3.011 1.809,-3.011 0.977,0 1.311,0.513 1.772,1.223 0.523,0.804 1.175,1.804 2.921,1.804 3.012,0 3.023,-4.76 3.04,-11.966 l 0.007,-2.264 -0.006,-2.064 c -0.017,-7.207 -0.028,-11.969 -3.04,-11.969 -1.746,0 -2.397,1.002 -2.921,1.807 -0.462,0.711 -0.796,1.225 -1.772,1.225 -0.889,0 -1.809,0 -1.809,-3.014 0,-0.207 -0.107,-9.752 -0.107,-9.752 0,-4.523 -3.606,-8.209 -8.039,-8.209 L 4.439,0.006 0.004,0 C 0.004,0 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.19,65.248)",
    id: "g24-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26-5",
    style: {
      fill: "#d6bd05",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -0.008 c -17.483,-0.099 -31.707,-14.716 -31.707,-32.584 0,-17.869 14.224,-32.485 31.708,-32.582 l 4.442,0.006 h 29.256 c 4.708,0 8.539,3.909 8.539,8.715 0.004,0.379 0.107,9.536 0.107,9.746 0,2.514 0.549,2.514 1.309,2.514 0.671,0 0.872,-0.256 1.354,-0.997 0.526,-0.811 1.322,-2.034 3.34,-2.034 3.511,0 3.522,4.96 3.54,12.467 10e-4,0.667 0.003,1.354 0.007,2.061 v 0.205 c -0.004,0.711 -0.006,1.399 -0.007,2.066 -0.018,7.506 -0.029,12.465 -3.54,12.465 -2.017,0 -2.812,-1.222 -3.34,-2.031 -0.481,-0.74 -0.683,-0.996 -1.354,-0.996 -0.76,0 -1.309,0 -1.309,2.511 0,0.209 -0.104,9.371 -0.107,9.76 0,4.793 -3.831,8.702 -8.539,8.702 H 4.434 Z m -0.002,-1 4.436,-0.008 h 29.257 c 4.164,0 7.539,-3.455 7.539,-7.713 0,0 0.107,-9.543 0.107,-9.749 0,-3.113 0.975,-3.511 2.309,-3.511 2.566,0 1.824,3.027 4.693,3.027 2.76,0 2.502,-5.619 2.547,-13.531 v -0.2 c -0.045,-7.91 0.213,-13.533 -2.547,-13.533 -2.869,0 -2.127,3.031 -4.693,3.031 -1.334,0 -2.309,-0.4 -2.309,-3.514 0,-0.207 -0.107,-9.746 -0.107,-9.746 0,-4.262 -3.375,-7.715 -7.539,-7.715 H 4.434 l -4.436,-0.006 c -16.978,0.096 -30.713,14.199 -30.713,31.584 0,17.387 13.735,31.488 30.713,31.584"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28-7"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g30-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g84-3"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.330002
    },
    id: "g82-2",
    clipPath: "url(#clipPath34-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g80-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g78-3",
    clipPath: "url(#clipPath38-0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g76-9"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g68-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74-9",
    mask: "url(#mask50-0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g72-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70-4",
    style: {
      fill: "url(#linearGradient5374)",
      stroke: "none"
    },
    d: "M 50.574,2.072 32.196,2.074 C 15.792,2.168 2.447,15.891 2.447,32.664 c 0,16.774 13.345,30.496 29.749,30.589 l 18.378,0.005 h 14.963 c 3.625,0 6.576,-3.014 6.576,-6.721 0.035,-3.298 0.105,-9.562 0.105,-9.754 0,-3.158 0.979,-4.505 3.279,-4.505 1.77,0 2.482,1.094 3,1.896 0.48,0.73 0.74,1.134 1.695,1.134 1.547,0 1.557,-5.079 1.568,-10.458 l 0.01,-2.284 c -0.006,-0.712 -0.006,-1.411 -0.008,-2.087 -0.014,-5.377 -0.023,-10.457 -1.57,-10.457 -0.955,0 -1.215,0.404 -1.695,1.135 -0.518,0.801 -1.23,1.895 -3,1.895 -2.301,0 -3.279,-1.348 -3.279,-4.508 0,-0.189 -0.07,-6.453 -0.105,-9.738 0,-3.717 -2.951,-6.732 -6.576,-6.732 H 50.574 Z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g86-8"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g88-0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g100-0"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.649994
    },
    id: "g98-4",
    clipPath: "url(#clipPath92-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g96-7",
    transform: "translate(32.196,61.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path94-2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 18.378,0.005 h 14.963 c 3.625,0 6.576,-3.016 6.576,-6.723 0.035,-3.297 0.105,-9.562 0.105,-9.752 0,-3.158 0.979,-4.505 3.279,-4.505 1.77,0 2.482,1.094 3,1.896 0.48,0.73 0.74,1.133 1.695,1.133 1.547,0 1.557,-5.08 1.568,-10.457 l 0.006,-1.625 0.004,0.743 -0.01,2.284 c -0.012,5.379 -0.021,10.458 -1.568,10.458 -0.955,0 -1.215,-0.403 -1.695,-1.134 -0.518,-0.802 -1.23,-1.896 -3,-1.896 -2.301,0 -3.279,1.347 -3.279,4.505 0,0.191 -0.07,6.456 -0.105,9.754 0,3.707 -2.951,6.721 -6.576,6.721 H 18.378 L 0,1.402 c -16.404,-0.093 -29.749,-13.815 -29.749,-30.589 0,-0.236 0.011,-0.467 0.017,-0.701 C -29.365,-13.437 -16.175,-0.093 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g102-3"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g104-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g158-5"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.600006
    },
    id: "g156-0",
    clipPath: "url(#clipPath108-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g154-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g152-8",
    clipPath: "url(#clipPath112-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g150-7"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g142-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g148-7",
    mask: "url(#mask124-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g146-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144-6",
    style: {
      fill: "url(#linearGradient5376)",
      stroke: "none"
    },
    d: "m 53.193,36.212 c 12.109,-0.183 22.918,-2.51 28.578,-3.531 -0.004,0.456 -0.008,1.542 -0.01,2.069 -0.012,5.379 -0.021,10.457 -1.568,10.457 -0.955,0 -1.215,-0.403 -1.695,-1.134 -0.518,-0.802 -1.23,-1.896 -3,-1.896 -2.301,0 -3.279,1.348 -3.279,4.505 0,0.192 -0.07,6.456 -0.105,9.755 0,3.706 -2.951,6.721 -6.576,6.721 H 50.574 c 0,0 -18.183,-0.004 -18.378,-0.006 C 17.727,63.071 5.645,52.385 2.993,38.355 c 7.453,-14.605 35.988,-1.93 50.2,-2.143"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.35277777,0,0,-0.35277777,235.44311,66.186026)",
    id: "g160-6"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath166-3)",
    id: "g162-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.02,44.99)",
    id: "g168-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path170-7",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -9.2 l -1.39,-1.44 c -0.78,0.68 -1.55,1.35 -2.29,1.99 -0.66,0.57 -1.31,1.13 -1.95,1.7 -0.55,0.47 -1.25,1.04 -2.05,1.44 -0.32,1.13 -1.15,2.05 -2.23,2.5 -0.45,0.19 -0.95,0.29 -1.47,0.29 -2.12,0 -3.84,-1.73 -3.84,-3.85 0,-0.55 0.12,-1.08 0.33,-1.56 0.44,-0.99 1.27,-1.76 2.31,-2.09 0.27,-0.74 0.7,-1.44 1.21,-2.03 0.93,-1.06 2.45,-2.62 4.22,-4.37 l -1.38,-1.44 -2.85,-1.65 -11.37,6.57 V 0 l 4.68,2.7 h 13.39 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.72,23.34)",
    id: "g172-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path174-2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 3.26,1.88 C 1.85,1.76 0.51,0.97 0,0 m -3.14,29.67 c -0.05,-0.11 -0.12,-0.22 -0.22,-0.31 -0.17,-0.18 -0.43,-0.3 -0.71,-0.3 -0.14,0 -0.28,0.03 -0.4,0.09 -0.12,0.04 -0.23,0.12 -0.31,0.2 -0.1,0.09 -0.17,0.2 -0.22,0.32 -0.05,0.12 -0.08,0.25 -0.08,0.39 0,0.28 0.11,0.53 0.3,0.72 0.18,0.18 0.43,0.29 0.71,0.29 0.21,0 0.4,-0.06 0.56,-0.16 0.27,-0.18 0.45,-0.49 0.45,-0.84 0,-0.14 -0.03,-0.28 -0.08,-0.4 M 9.7,24.54 3.62,28.06 -2.77,31.74 c -0.41,0.23 -0.85,0.35 -1.31,0.35 -0.22,0 -0.45,-0.03 -0.67,-0.09 -0.22,-0.07 -0.44,-0.16 -0.64,-0.27 l -6.38,-3.68 -6.07,-3.51 h -0.01 c -0.2,-0.11 -0.38,-0.25 -0.54,-0.42 -0.48,-0.49 -0.76,-1.16 -0.76,-1.86 V 7.88 c 0,-0.24 0.03,-0.47 0.09,-0.69 0.17,-0.66 0.61,-1.23 1.21,-1.58 l 12.46,-7.2 c 0.21,-0.11 0.42,-0.2 0.64,-0.26 0.22,-0.07 0.45,-0.1 0.68,-0.1 0.33,0 0.67,0.07 0.99,0.21 0.1,0.04 0.21,0.09 0.31,0.15 l 0.42,0.24 c -0.04,0.61 0.11,1.26 0.43,1.95 0.32,0.78 0.91,1.48 1.66,2.03 -0.33,0.32 -0.66,0.64 -0.97,0.96 L -4.08,1.94 -15.45,8.51 v 13.14 l 4.68,2.7 H 2.62 l 4.68,-2.7 v -9.2 c 0.42,-0.37 0.85,-0.74 1.27,-1.11 0.18,0.14 0.36,0.29 0.56,0.44 0.55,0.43 1.19,0.75 1.88,0.95 v 9.54 c 0,0.94 -0.5,1.81 -1.31,2.27 M 8.55,8.66 C 6.98,10.09 5.21,11.62 3.62,13 c -0.66,0.57 -1.31,1.13 -1.95,1.7 -0.55,0.47 -1.25,1.04 -2.05,1.44 -0.32,1.13 -1.15,2.05 -2.23,2.5 -0.45,0.19 -0.95,0.29 -1.47,0.29 -2.12,0 -3.84,-1.73 -3.84,-3.85 0,-0.55 0.12,-1.08 0.33,-1.56 0.44,-0.99 1.27,-1.76 2.31,-2.09 0.27,-0.74 0.7,-1.44 1.21,-2.03 C -2.62,7.74 0.31,4.83 3.34,1.93 L 4.24,2.45 5.13,2.97 9.7,5.6 c 0.81,0.47 1.31,1.34 1.31,2.28 V 10.6 C 10.79,10.5 10.57,10.36 10.36,10.2 9.61,9.62 8.99,9.08 8.55,8.66"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.58,53.01)",
    id: "g176-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path178-1",
    style: {
      fill: "none",
      stroke: "#898345",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.05,-0.11 -0.12,-0.22 -0.22,-0.31 -0.19,-0.18 -0.44,-0.29 -0.72,-0.29 -0.27,0 -0.52,0.11 -0.7,0.28 -0.05,0.05 -0.09,0.09 -0.13,0.15 -0.11,0.16 -0.18,0.36 -0.18,0.57 0,0.17 0.04,0.32 0.11,0.46 0.06,0.09 0.12,0.18 0.2,0.25 0.09,0.09 0.19,0.17 0.31,0.22 0.12,0.05 0.25,0.08 0.39,0.08 0.07,0 0.13,-0.01 0.2,-0.02 0.07,-0.01 0.13,-0.03 0.19,-0.06 0.2,-0.08 0.36,-0.22 0.47,-0.39 0.03,-0.05 0.06,-0.1 0.07,-0.15 C 0.05,0.67 0.08,0.54 0.08,0.4 0.08,0.26 0.05,0.12 0,0 Z m 13.8,-6.09 c 0,0 -0.01,0 -0.01,0.01 -0.11,0.19 -0.24,0.37 -0.4,0.53 -0.17,0.16 -0.35,0.31 -0.56,0.43 L 6.76,-1.61 0.37,2.07 c -0.1,0.06 -0.21,0.11 -0.31,0.15 -0.32,0.13 -0.66,0.2 -1,0.2 -0.22,0 -0.45,-0.03 -0.67,-0.09 C -1.72,2.3 -1.83,2.27 -1.93,2.22 -2.05,2.18 -2.15,2.13 -2.26,2.07 l -6.38,-3.68 -6.06,-3.52 h -0.01 c -0.1,-0.06 -0.2,-0.12 -0.29,-0.19 -0.08,-0.07 -0.17,-0.15 -0.25,-0.23 -0.09,-0.09 -0.16,-0.18 -0.23,-0.27 -0.07,-0.08 -0.13,-0.17 -0.18,-0.26 -0.24,-0.39 -0.36,-0.85 -0.36,-1.32 v -14.39 c 0,-0.24 0.03,-0.46 0.1,-0.68 0.03,-0.11 0.07,-0.22 0.11,-0.32 0.04,-0.11 0.09,-0.21 0.15,-0.31 0.1,-0.17 0.22,-0.33 0.35,-0.48 0.03,-0.02 0.05,-0.04 0.06,-0.06 0.08,-0.08 0.17,-0.16 0.26,-0.23 0.09,-0.06 0.18,-0.13 0.28,-0.19 h 0.01 l 12.44,-7.19 c 0.41,-0.23 0.87,-0.36 1.32,-0.36 0.22,0 0.45,0.03 0.67,0.09 0.11,0.03 0.22,0.07 0.33,0.11 0.1,0.04 0.21,0.09 0.31,0.15 l 0.42,0.24 v 0.01 c -0.04,0.61 0.11,1.25 0.43,1.94 0.32,0.78 0.91,1.48 1.66,2.03 -0.33,0.32 -0.66,0.64 -0.97,0.96 l -2.85,-1.65 -11.37,6.57 v 13.14 l 4.68,2.7 H 5.76 l 4.68,-2.7 v -9.2 c 0.42,-0.37 0.85,-0.74 1.27,-1.11 0.18,0.14 0.36,0.29 0.56,0.44 0.55,0.43 1.18,0.75 1.87,0.95 h 0.01 v 9.54 c 0,0.47 -0.13,0.92 -0.35,1.31 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.64,38.42)",
    id: "g180-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path182-5",
    style: {
      fill: "#898345",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,-0.16 -0.02,-0.31 -0.05,-0.45 -0.22,-1.19 -0.8,-1.77 -1.54,-1.94 V -1.95 C -1.69,-1.98 -1.84,-2 -2,-2 c -0.18,0 -0.36,0.02 -0.53,0.07 -0.38,0.11 -0.71,0.33 -0.96,0.62 -0.31,0.35 -0.5,0.81 -0.5,1.31 0,1.1 0.9,1.99 1.99,1.99 0.49,0 0.94,-0.18 1.29,-0.47 0.3,-0.25 0.52,-0.59 0.63,-0.97 C -0.03,0.38 0,0.19 0,0 M 1.7,1.06 C 1.38,2.19 0.55,3.11 -0.53,3.56 -0.98,3.75 -1.48,3.85 -2,3.85 -4.12,3.85 -5.84,2.12 -5.84,0 c 0,-0.55 0.12,-1.08 0.33,-1.56 0.44,-0.99 1.27,-1.76 2.31,-2.09 0.37,-0.13 0.77,-0.2 1.18,-0.2 H -2 c 0.36,0 0.71,0.05 1.04,0.15 1.22,0.34 2.19,1.26 2.6,2.45 0.12,0.34 0.19,0.7 0.2,1.07 0.01,0.06 0.01,0.12 0.01,0.18 0,0.37 -0.05,0.72 -0.15,1.06"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.58,53.01)",
    id: "g184-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path186-16",
    style: {
      fill: "#34332b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.05,-0.11 -0.12,-0.22 -0.22,-0.31 -0.19,-0.18 -0.44,-0.29 -0.72,-0.29 -0.27,0 -0.52,0.11 -0.7,0.28 -0.05,0.05 -0.09,0.09 -0.13,0.15 -0.11,0.16 -0.18,0.36 -0.18,0.57 0,0.17 0.04,0.32 0.11,0.46 0.06,0.09 0.12,0.18 0.2,0.25 0.09,0.09 0.19,0.17 0.31,0.22 0.12,0.05 0.25,0.08 0.39,0.08 0.07,0 0.13,-0.01 0.2,-0.02 0.07,-0.01 0.13,-0.03 0.19,-0.06 0.2,-0.08 0.36,-0.22 0.47,-0.39 0.03,-0.05 0.06,-0.1 0.07,-0.15 C 0.05,0.67 0.08,0.54 0.08,0.4 0.08,0.26 0.05,0.12 0,0 m 13.8,-6.09 c 0,0 -0.01,0 -0.01,0.01 -0.11,0.19 -0.24,0.37 -0.4,0.53 -0.17,0.16 -0.35,0.31 -0.56,0.43 L 6.76,-1.61 0.37,2.07 c -0.1,0.06 -0.21,0.11 -0.31,0.15 -0.32,0.13 -0.66,0.2 -1,0.2 -0.22,0 -0.45,-0.03 -0.67,-0.09 C -1.72,2.3 -1.83,2.27 -1.93,2.22 -2.05,2.18 -2.15,2.13 -2.26,2.07 l -6.38,-3.68 -6.06,-3.52 h -0.01 c -0.1,-0.06 -0.2,-0.12 -0.29,-0.19 -0.08,-0.07 -0.17,-0.15 -0.25,-0.23 -0.09,-0.09 -0.16,-0.18 -0.23,-0.27 -0.07,-0.08 -0.13,-0.17 -0.18,-0.26 -0.24,-0.39 -0.36,-0.85 -0.36,-1.32 v -14.39 c 0,-0.24 0.03,-0.46 0.1,-0.68 0.03,-0.11 0.07,-0.22 0.11,-0.32 0.04,-0.11 0.09,-0.21 0.15,-0.31 0.1,-0.17 0.22,-0.33 0.35,-0.48 0.03,-0.02 0.05,-0.04 0.06,-0.06 0.08,-0.08 0.17,-0.16 0.26,-0.23 0.09,-0.06 0.18,-0.13 0.28,-0.19 h 0.01 l 12.44,-7.19 c 0.41,-0.23 0.87,-0.36 1.32,-0.36 0.22,0 0.45,0.03 0.67,0.09 0.11,0.03 0.22,0.07 0.33,0.11 0.1,0.04 0.21,0.09 0.31,0.15 l 0.42,0.24 v 0.01 c -0.04,0.61 0.11,1.25 0.43,1.94 0.32,0.78 0.91,1.48 1.66,2.03 -0.33,0.32 -0.66,0.64 -0.97,0.96 l -2.85,-1.65 -11.37,6.57 v 13.14 l 4.68,2.7 H 5.76 l 4.68,-2.7 v -9.2 c 0.42,-0.37 0.85,-0.74 1.27,-1.11 0.18,0.14 0.36,0.29 0.56,0.44 0.55,0.43 1.18,0.75 1.87,0.95 h 0.01 v 9.54 c 0,0.47 -0.13,0.92 -0.35,1.31"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.5668,38.4164)",
    id: "g188-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path190-6",
    style: {
      fill: "#34332b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-1.613 -1.308,-2.921 -2.921,-2.921 -1.613,0 -2.921,1.308 -2.921,2.921 0,1.613 1.308,2.921 2.921,2.921 C -1.308,2.921 0,1.613 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.21,20.5)",
    id: "g192-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path194-7",
    style: {
      fill: "#898345",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.54,-3.81 -1.83,-7.88 -10.32,-7.93 -0.52,0.18 -1.01,0.32 -1.49,0.47 -0.63,0.18 -1.22,0.36 -1.9,0.61 -0.27,0.1 -0.53,0.2 -0.79,0.31 -0.71,0.28 -1.45,0.58 -2.19,0.73 -0.62,0.13 -1.43,0.57 -2.36,1.08 l -0.84,0.45 c -0.81,0.45 -1.65,0.9 -2.5,1.24 -1.29,0.5 -1.87,1.52 -2.52,2.65 -0.47,0.82 -0.95,1.68 -1.78,2.36 0.19,0.27 0.98,0.78 1.89,0.78 0.35,0 0.7,-0.08 1.03,-0.23 0.18,-0.08 0.45,-0.29 0.77,-0.53 0.64,-0.51 1.53,-1.2 2.45,-1.36 l 3.31,-0.6 -2.45,2.31 c -1.04,0.98 -2.32,2.19 -3.67,3.47 l -0.01,0.01 c -2.95,2.84 -6.19,6.01 -7.68,7.73 -0.15,0.18 -0.32,0.41 -0.48,0.67 -0.16,0.26 -0.3,0.55 -0.41,0.85 -0.1,0.3 -0.17,0.6 -0.17,0.9 v 0.01 c 0,0.43 0.14,0.84 0.5,1.18 0.22,0.21 0.47,0.35 0.81,0.32 0.06,0 0.12,0 0.18,-0.01 0.29,-0.04 0.59,-0.15 0.88,-0.29 0.29,-0.15 0.57,-0.33 0.81,-0.51 0.35,-0.26 0.63,-0.5 0.79,-0.64 0.65,-0.57 1.3,-1.14 1.96,-1.7 1.82,-1.58 3.88,-3.37 5.58,-4.93 l 0.71,-0.67 0.68,0.7 c 0.13,0.14 0.77,0.78 1.72,1.56 l 0.01,0.01 c 0.18,0.15 0.37,0.31 0.58,0.47 0.36,0.28 0.85,0.34 1.2,0.34 0.38,0 0.79,-0.08 1.09,-0.21 l 0.58,-0.27 0.48,0.42 c 1.51,1.31 1.84,1.51 1.86,1.52 0.36,0.19 0.77,0.29 1.19,0.29 0.7,-0.01 1.45,-0.27 2,-0.78 l 0.41,-0.38 0.54,0.15 c 0.89,0.25 1.69,0.39 2.21,0.39 0.89,0 1.81,-1.27 2.42,-2.22 C -0.02,6.22 0.64,4.57 0,0 m -1.24,11.8 c -0.99,1.56 -2.26,3.14 -4.1,3.14 -0.72,0 -1.55,-0.15 -2.24,-0.33 -0.85,0.62 -1.85,0.95 -2.89,0.95 -0.73,0.01 -1.48,-0.17 -2.15,-0.52 -0.13,-0.07 -0.42,-0.22 -1.8,-1.4 -0.53,0.15 -1,0.17 -1.28,0.17 -0.49,0 -1.14,-0.07 -1.78,-0.37 l -0.01,-0.01 c -0.22,-0.09 -0.43,-0.23 -0.64,-0.39 -0.75,-0.58 -1.37,-1.12 -1.81,-1.54 -1.57,1.43 -3.34,2.96 -4.93,4.34 -0.66,0.57 -1.31,1.13 -1.95,1.7 -0.55,0.47 -1.25,1.04 -2.05,1.44 -0.37,0.18 -0.76,0.33 -1.17,0.41 -0.24,0.06 -0.5,0.09 -0.75,0.09 -0.17,0 -0.33,-0.01 -0.49,-0.04 -0.64,-0.09 -1.24,-0.38 -1.71,-0.84 -0.62,-0.59 -0.95,-1.27 -1.07,-1.99 -0.06,-0.39 -0.06,-0.8 -0.01,-1.2 0.05,-0.39 0.15,-0.77 0.3,-1.14 0.27,-0.74 0.7,-1.44 1.21,-2.03 1.45,-1.66 4.37,-4.56 7.4,-7.46 l 0.04,-0.04 c -0.04,0 -0.07,-0.01 -0.11,-0.02 -0.02,0 -0.03,0 -0.05,-0.01 -1.38,-0.13 -2.68,-0.89 -3.19,-1.84 -0.01,-0.01 -0.01,-0.02 -0.02,-0.03 -0.03,-0.07 -0.06,-0.13 -0.09,-0.2 -0.38,-0.81 -0.26,-1.19 -0.21,-1.34 0.04,-0.13 0.15,-0.48 0.84,-0.88 0.54,-0.45 0.89,-1.08 1.33,-1.85 0.69,-1.21 1.56,-2.71 3.5,-3.48 0.73,-0.28 1.52,-0.71 2.27,-1.12 l 0.84,-0.46 c 1.07,-0.58 2,-1.09 2.91,-1.28 0.58,-0.12 1.2,-0.37 1.85,-0.63 0.28,-0.11 0.56,-0.22 0.84,-0.33 0.75,-0.27 1.4,-0.47 2.04,-0.65 0.48,-0.15 0.97,-0.29 1.5,-0.47 0.14,-0.05 0.31,-0.08 0.46,-0.08 C -0.7,-9.91 1.3,-5.04 1.98,-0.28 2.7,4.81 1.94,6.87 -1.24,11.8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.666,11.5925)",
    id: "g196-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path198-3",
    style: {
      fill: "#34332b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.248,0.428 -2.244,0.648 -3.517,1.119 -0.939,0.347 -1.907,0.808 -2.833,0.999 -0.886,0.182 -1.914,0.79 -3.106,1.435 -0.905,0.489 -1.839,1.02 -2.753,1.38 -1.628,0.637 -2.364,1.939 -3.014,3.073 -0.461,0.806 -0.896,1.572 -1.618,2.146 0,0 -0.412,0.227 -0.456,0.367 -0.05,0.157 0.182,0.635 0.182,0.635 0.248,0.709 1.52,1.504 2.855,1.504 0.498,0 0.985,-0.105 1.446,-0.316 0.288,-0.13 0.586,-0.361 0.964,-0.657 0.574,-0.446 1.343,-1.047 2.016,-1.168 -2.993,2.816 -9.154,8.667 -11.423,11.287 -1.245,1.44 -1.933,3.615 -0.501,4.985 0.403,0.39 0.944,0.607 1.505,0.603 1.23,0 2.482,-0.97 3.315,-1.7 0.65,-0.568 1.302,-1.135 1.955,-1.7 1.834,-1.589 3.907,-3.384 5.603,-4.955 0.278,0.287 1.153,1.15 2.407,2.126 0.59,0.46 1.313,0.557 1.813,0.557 0.459,0 1.018,-0.086 1.501,-0.304 0.772,0.669 1.746,1.489 2.051,1.653 0.518,0.268 1.094,0.406 1.677,0.401 0.983,0 1.926,-0.375 2.655,-1.047 0.611,0.172 1.662,0.429 2.481,0.429 1.354,0 2.409,-1.356 3.263,-2.684 3.088,-4.8 3.741,-6.614 3.066,-11.396 C 10.904,4.327 9.111,-0.007 0.128,-0.021 0.093,-0.022 0.033,-0.011 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.6139395,0,0,-0.6139395,98.353005,411.78867)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12-9"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18-83)",
    id: "g14-9"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.727,0.85)",
    id: "g20-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22-6",
    style: {
      fill: "#43d3ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -4.649,0 -8.727,3.838 -8.727,8.212 0,0 0.013,5.81 0.013,9.332 0,1.348 0.13,2.725 1.092,2.725 0.555,0 1.033,-0.544 1.58,-1.36 0.712,-1.062 1.736,-1.622 3.13,-1.71 0.083,-0.005 0.163,-0.008 0.242,-0.008 1.003,0 1.587,0.41 2.375,1.217 1.233,1.264 1.289,3.469 1.352,13.67 -0.063,10.194 -0.119,12.397 -1.352,13.662 -0.788,0.807 -1.372,1.217 -2.375,1.217 -0.078,0 -0.159,-0.003 -0.242,-0.008 -1.393,-0.086 -2.416,-0.645 -3.129,-1.708 -0.547,-0.817 -1.025,-1.362 -1.58,-1.362 -0.962,0 -1.092,1.378 -1.092,2.726 -0.001,3.52 -0.014,9.331 -0.014,9.331 0,4.376 4.078,8.214 8.727,8.214 h 47.546 c 4.435,0 8.041,-3.684 8.041,-8.213 0,0 0.104,-9.542 0.104,-9.749 0,-3.01 0.921,-3.01 1.812,-3.01 0.979,0 1.312,0.513 1.772,1.224 0.522,0.804 1.177,1.804 2.92,1.804 3.011,0 3.021,-4.752 3.039,-11.946 l 0.009,-2.285 -0.009,-2.084 c -0.019,-7.195 -0.028,-11.948 -3.039,-11.948 -1.743,0 -2.396,1.001 -2.92,1.807 -0.462,0.711 -0.796,1.226 -1.772,1.226 -0.891,0 -1.812,0 -1.812,-3.015 0,-0.207 -0.104,-9.752 -0.104,-9.752 C 55.587,3.687 51.981,0 47.546,0 47.546,0 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.273,65.5)",
    id: "g24-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26-2",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -47.546 c -4.915,0 -9.227,-4.071 -9.227,-8.713 0,-0.002 0.013,-5.812 0.013,-9.332 0,-0.965 0,-3.226 1.592,-3.226 0.863,0 1.483,0.818 1.996,1.584 0.395,0.589 1.11,1.385 2.744,1.486 0.073,0.004 0.143,0.007 0.211,0.007 0.835,0 1.297,-0.329 2.018,-1.067 1.097,-1.125 1.148,-3.288 1.209,-13.321 -0.062,-10.023 -0.113,-12.188 -1.21,-13.312 -0.719,-0.734 -1.181,-1.063 -2.017,-1.063 -0.069,0 -0.139,0.002 -0.212,0.007 -1.634,0.1 -2.348,0.897 -2.744,1.487 -0.513,0.766 -1.132,1.582 -1.995,1.582 -0.305,0 -1.05,-0.115 -1.379,-1.188 -0.144,-0.472 -0.213,-1.138 -0.213,-2.037 0,-3.521 -0.013,-9.33 -0.013,-9.33 0,-4.646 4.312,-8.717 9.227,-8.717 H 0 c 4.711,0 8.541,3.908 8.541,8.715 0.004,0.379 0.104,9.537 0.104,9.746 0,2.514 0.552,2.514 1.312,2.514 0.672,0 0.873,-0.256 1.354,-0.997 0.525,-0.81 1.322,-2.033 3.339,-2.033 3.509,0 3.521,4.951 3.539,12.446 0.002,0.674 0.004,1.367 0.009,2.08 v 0.206 c -0.005,0.719 -0.007,1.413 -0.009,2.086 -0.021,7.494 -0.03,12.445 -3.539,12.445 -2.017,0 -2.812,-1.222 -3.339,-2.031 -0.48,-0.74 -0.684,-0.996 -1.354,-0.996 -0.76,0 -1.312,0 -1.312,2.51 0,0.21 -0.103,9.37 -0.104,9.76 C 8.541,-3.909 4.709,0 0,0 m 0,-1 c 4.166,0 7.541,-3.454 7.541,-7.713 0,0 0.104,-9.542 0.104,-9.749 0,-3.113 0.979,-3.51 2.312,-3.51 2.566,0 1.824,3.027 4.691,3.027 2.762,0 2.5,-5.62 2.549,-13.531 v -0.201 c -0.049,-7.909 0.213,-13.532 -2.549,-13.532 -2.867,0 -2.125,3.029 -4.691,3.029 -1.332,0 -2.312,-0.399 -2.312,-3.512 0,-0.207 -0.104,-9.748 -0.104,-9.748 0,-4.263 -3.375,-7.713 -7.541,-7.713 h -47.546 c -4.164,0 -8.227,3.45 -8.227,7.713 0,0 0.013,5.811 0.013,9.332 0,1.685 0.255,2.226 0.592,2.226 0.365,0 0.826,-0.634 1.165,-1.14 0.586,-0.873 1.588,-1.81 3.514,-1.932 0.094,-0.006 0.185,-0.009 0.273,-0.009 1.241,0 1.944,0.562 2.732,1.367 1.385,1.42 1.43,3.54 1.494,14.017 -0.064,10.479 -0.109,12.598 -1.494,14.017 -0.789,0.809 -1.491,1.369 -2.733,1.369 -0.088,0 -0.179,-0.003 -0.273,-0.009 -1.926,-0.119 -2.928,-1.055 -3.514,-1.928 -0.339,-0.507 -0.8,-1.141 -1.165,-1.141 -0.337,0 -0.592,0.542 -0.592,2.226 0,3.521 -0.013,9.332 -0.013,9.332 10e-4,4.259 4.063,7.713 8.228,7.713 L 0,-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g28-1"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g30-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96-74"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.199997
    },
    id: "g94",
    clipPath: "url(#clipPath34-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g90",
    clipPath: "url(#clipPath38-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g88-2"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g80-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86-4",
    mask: "url(#mask56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g84-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "url(#linearGradient4)",
      stroke: "none"
    },
    d: "m 9.727,2.341 c -3.797,0 -7.255,3.203 -7.255,6.722 0,0 0.013,5.812 0.013,9.332 0,0.184 0.004,0.342 0.008,0.485 0.973,-1.427 2.396,-2.208 4.232,-2.319 0.115,-0.008 0.227,-0.011 0.333,-0.011 1.663,0 2.601,0.82 3.419,1.658 1.7,1.739 1.713,3.976 1.778,14.709 C 12.19,43.666 12.177,45.901 10.477,47.641 9.658,48.479 8.721,49.3 7.058,49.3 6.952,49.3 6.84,49.296 6.725,49.29 4.887,49.177 3.465,48.395 2.493,46.97 c -0.005,0.162 -0.008,0.323 -0.008,0.485 0,3.521 -0.013,9.332 -0.013,9.332 0,3.516 3.458,6.719 7.255,6.719 h 47.546 c 3.623,0 6.572,-3.016 6.572,-6.719 0.032,-3.298 0.104,-9.558 0.106,-9.749 0,-3.157 0.979,-4.504 3.276,-4.504 1.769,0 2.479,1.093 3,1.893 0.476,0.732 0.737,1.135 1.692,1.135 1.545,0 1.554,-5.079 1.567,-10.454 0,-0.675 0.011,-2.283 0.011,-2.283 -0.008,-0.71 -0.011,-1.409 -0.011,-2.085 -0.016,-5.374 -0.022,-10.453 -1.567,-10.453 -0.955,0 -1.219,0.404 -1.692,1.135 -0.521,0.803 -1.231,1.895 -3,1.895 -2.299,0 -3.276,-1.348 -3.276,-4.506 -0.002,-0.188 -0.074,-6.449 -0.106,-9.734 0,-3.719 -2.949,-6.732 -6.572,-6.732 H 9.727 Z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g98-3"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g100-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g154-1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    },
    id: "g152-7",
    clipPath: "url(#clipPath104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g150-75"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g148-8",
    clipPath: "url(#clipPath108-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g146-4"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g144",
    mask: "url(#mask120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g142-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "url(#linearGradient5)",
      stroke: "none"
    },
    d: "m 2.492,46.97 c 0.973,1.426 2.395,2.207 4.232,2.32 0.115,0.006 0.227,0.01 0.333,0.01 1.663,0 2.601,-0.82 3.419,-1.659 1.607,-1.645 1.707,-6.122 1.768,-15.423 18.04,-4.051 26.213,1.793 45.277,1.793 11.387,0 8.021,-0.692 15.975,-1.907 0.004,0.244 0.004,0.478 0.006,0.723 0,0 -0.01,1.608 -0.01,2.283 -0.016,5.375 -0.023,10.454 -1.568,10.454 -0.955,0 -1.219,-0.402 -1.693,-1.135 -0.521,-0.8 -1.23,-1.893 -3,-1.893 -2.299,0 -3.275,1.347 -3.275,4.504 -0.002,0.191 -0.074,6.451 -0.105,9.749 0,3.703 -2.949,6.719 -6.572,6.719 H 9.727 c -3.797,0 -7.255,-3.203 -7.255,-6.719 0,0 0.013,-5.811 0.013,-9.332 -10e-4,-0.185 0.003,-0.345 0.007,-0.487"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "g156-4"
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "g158-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g170"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.899994
    },
    id: "g168-5",
    clipPath: "url(#clipPath162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g166",
    transform: "translate(2.484,16.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0.183 0.004,0.343 0.008,0.485 0.973,-1.427 2.396,-2.207 4.232,-2.319 0.115,-0.009 0.227,-0.013 0.333,-0.013 1.663,0 2.601,0.818 3.419,1.66 1.7,1.737 1.713,3.977 1.778,14.711 l -0.005,0.7 C 9.703,5.094 9.654,2.916 7.992,1.214 7.174,0.379 6.237,-0.441 4.574,-0.441 4.468,-0.441 4.356,-0.438 4.241,-0.43 2.405,-0.319 0.981,0.465 0.009,1.889 0.004,1.727 0.001,1.566 0.001,1.404 c 0,-3.521 -0.013,-9.332 -0.013,-9.332 L -0.01,-7.977 C -0.005,-6.05 0,-2.464 0,0 m 7.243,45.112 h 47.546 c 3.623,0 6.572,-3.014 6.572,-6.719 0.032,-3.296 0.104,-9.558 0.106,-9.75 0,-3.154 0.979,-4.504 3.276,-4.504 1.769,0 2.479,1.096 3,1.895 0.476,0.731 0.737,1.135 1.692,1.135 1.545,0 1.554,-5.077 1.567,-10.453 0,-0.393 0.003,-1.102 0.005,-1.625 0,0.252 0,0.491 0.006,0.743 0,0 -0.011,1.608 -0.011,2.283 -0.016,5.375 -0.022,10.454 -1.567,10.454 -0.955,0 -1.219,-0.402 -1.692,-1.135 -0.521,-0.8 -1.231,-1.893 -3,-1.893 -2.299,0 -3.276,1.347 -3.276,4.504 -0.002,0.191 -0.074,6.451 -0.106,9.749 0,3.703 -2.949,6.719 -6.572,6.719 H 7.243 c -3.797,0 -7.255,-3.203 -7.255,-6.719 l 0.002,-1.355 c 0.031,3.497 3.473,6.671 7.253,6.671"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "g172-3"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath178)",
    id: "g174"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.2855,18.2155)",
    id: "g180-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path182-58",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.727,0.006 -1.42,0.308 -1.92,0.836 -2.276,1.838 -9.374,7.791 -9.374,10.57 0,2.465 1.409,3.343 2.727,3.343 0.137,0 0.277,-0.009 0.42,-0.026 l 2.762,-0.173 c 0.069,-0.003 0.135,0.026 0.179,0.078 0.112,0.125 0.163,0.358 0.136,0.624 l -0.009,0.076 0.003,0.075 c 0.002,0.036 0.174,3.621 0.174,6.548 0,2.074 -2.302,3.684 -4.281,3.684 -2.03,0 -3.684,-1.664 -3.684,-3.695 0,-2.468 -1.384,-2.998 -2.545,-2.998 h -6.242 c -2.206,0 -2.209,2.188 -2.211,3.006 0.004,8.092 6.59,14.68 14.682,14.68 C -1.086,36.628 5.5,30.049 5.5,21.959 5.5,18.23 5.086,15.333 5.069,15.212 5.046,14.985 5.095,14.753 5.21,14.628 5.254,14.576 5.319,14.547 5.387,14.551 L 8.21,14.73 c 0.066,0.01 0.191,0.018 0.314,0.018 1.379,0 2.77,-1.032 2.77,-3.34 C 11.294,8.933 4.786,3.23 1.927,0.846 1.428,0.311 0.731,0.005 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.5565,31.9455)",
    id: "g184-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path186-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -2.717,-0.17 c -0.926,-0.111 -1.591,0.695 -1.477,1.795 0,0 0.421,2.906 0.421,6.605 0,7.551 -6.129,13.672 -13.683,13.672 -7.553,0 -13.677,-6.133 -13.682,-13.684 0.004,-1.101 0.11,-2.007 1.213,-2.007 h 6.242 c 1.545,0 1.545,1.285 1.545,1.998 -10e-4,2.588 2.097,4.687 4.685,4.689 2.586,0 5.279,-2.093 5.279,-4.681 0,-2.986 -0.174,-6.595 -0.174,-6.595 0.114,-1.1 -0.55,-1.905 -1.479,-1.794 l -2.715,0.171 c -1.113,0.137 -2.023,-0.455 -2.023,-2.324 0,-2.542 9.059,-9.837 9.059,-9.837 0.68,-0.76 1.791,-0.76 2.471,0 0,0 9.059,7.547 9.059,9.837 C 2.021,-0.611 1.111,0.137 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.4655,20.1565)",
    id: "g188-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path190-61",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.68,0 -2.888,0.913 -2.888,2.624 v 2.75 C -2.888,7.085 -1.68,8 0,8 H 4.91 C 6.588,8 8.112,7.085 8.112,5.374 V 2.624 C 8.112,0.913 6.588,0 4.91,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.3755,27.1565)",
    id: "g192-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path194-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -4.91 c -1.131,0 -1.888,-0.466 -1.888,-1.626 v -2.75 C -6.798,-5.538 -6.041,-6 -4.91,-6 H 0 c 1.129,0 2.202,0.462 2.202,1.624 v 2.75 C 2.202,-0.466 1.129,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.4655,11.1565)",
    id: "g196-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path198-00",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.68,0 -2.888,0.913 -2.888,2.624 v 2.75 C -2.888,7.085 -1.68,8 0,8 H 4.91 C 6.588,8 8.112,7.085 8.112,5.374 V 2.624 C 8.112,0.913 6.588,0 4.91,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.3755,18.1565)",
    id: "g200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path202",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -4.91 c -1.131,0 -1.888,-0.466 -1.888,-1.626 v -2.75 C -6.798,-5.538 -6.041,-6 -4.91,-6 H 0 c 1.129,0 2.202,0.462 2.202,1.624 v 2.75 C 2.202,-0.466 1.129,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.4655,29.1565)",
    id: "g204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path206",
    style: {
      fill: "#308ba0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.68,0 -2.888,0.913 -2.888,2.624 v 1.75 C -2.888,6.085 -1.68,7 0,7 H 4.91 C 6.588,7 8.112,6.085 8.112,4.374 V 2.624 C 8.112,0.913 6.588,0 4.91,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.3755,35.1565)",
    id: "g208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path210",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -4.91 c -1.131,0 -1.888,-0.466 -1.888,-1.626 v -1.75 C -6.798,-4.538 -6.041,-5 -4.91,-5 H 0 c 1.129,0 2.202,0.462 2.202,1.624 v 1.75 C 2.202,-0.466 1.129,0 0,0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonJumpConnected);
export default __webpack_public_path__ + "static/media/button-jump-connected.ff63675087751946ef16eeb7031ff135.svg";
export { ForwardRef as ReactComponent };